import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=5e9ab022&"
import script from "./UserLogs.vue?vue&type=script&lang=ts&"
export * from "./UserLogs.vue?vue&type=script&lang=ts&"
import style0 from "./UserLogs.vue?vue&type=style&index=0&id=5e9ab022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports